import React from "react";
import {
  Alert,
  Stack,
  Text,
  List,
  ListItem,
  TextLink,
} from "@origin-digital/ods-core";

const LifeSupportAlert: React.FC = () => {
  return (
    <Alert title="Important information for life support customers">
      <Stack space="medium">
        <Text>
          Registering for life support with Origin for the first time at this
          property with this energy type:
        </Text>
        <List space="xsmall">
          <ListItem>
            We'll send you information on how to register your premises as
            requiring life support, including how to provide valid medical
            confirmation.
          </ListItem>
          <ListItem>
            Once it has been signed by a registered medical practitioner, return
            your medical confirmation to us so we have a record of your life
            support requirements.
          </ListItem>
          <ListItem>
            Your contact details, including email address, will be sent to the
            distributor for the purpose of life support requirements, such as
            outage notifications. If you want the contact details to be changed,
            please contact Origin.
          </ListItem>
        </List>
        <Text>
          Please contact us on{" "}
          <TextLink href="mailto:ncorigin@originenergy.com.au">
            NCOrigin@originenergy.com.au
          </TextLink>{" "}
          for any questions regarding your life support requirements.
        </Text>
      </Stack>
    </Alert>
  );
};

export default LifeSupportAlert;
